import React, { useState, useCallback } from 'react';
import {
    GoogleMap,
    useLoadScript,
    Marker,
    Autocomplete
} from '@react-google-maps/api';

const libraries = ['places'];
const mapContainerStyle = {
    height: '500px',
    width: '100%',
};

const center = {
    lat: 28.6139, // Default to Delhi
    lng: 77.2090,
};

const MapPicker = ({ location, setLocation, setAddress, address }) => {
    // const [location, setLocation] = useState(center);
    // const [address, setAddress] = useState('');
    const [autocomplete, setAutocomplete] = useState(null);



    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: 'AIzaSyDKwHjvaZUM4ErXn31l12Y9yZ9Ua7CHjuI',
        libraries,
    });

    const onMapClick = useCallback((e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        setLocation({ lat, lng });
        fetchAddress(lat, lng);
    }, []);

    const fetchAddress = async (lat, lng) => {
        const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyDKwHjvaZUM4ErXn31l12Y9yZ9Ua7CHjuI`
        );
        const data = await response.json();
        if (data.results[0]) {
            setAddress(data.results[0].formatted_address);
        } else {
            setAddress('Address not found');
        }
    };

    const handlePlaceChanged = () => {
        const place = autocomplete.getPlace();


        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        setLocation({ lat, lng });
        setAddress(place.formatted_address);
    };

    const getCurrentLocation = () => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;
                setLocation({ lat, lng });
                fetchAddress(lat, lng);
            },
            () => alert('Failed to fetch current location')
        );
    };


    if (loadError) return <div>Error loading maps</div>;
    if (!isLoaded) return <div>Loading Maps...</div>;

    return (
        <div className="p-4 space-y-4">
            <div className="flex gap-4 relative z-50  w-full justify-center items-center">
                <Autocomplete
                    onLoad={(autoC) => setAutocomplete(autoC)}
                    onPlaceChanged={handlePlaceChanged}
                >
                    <input
                        type="text"
                        placeholder="Search location"
                        className="border px-3 py-2 w-full rounded shadow"
                    />
                </Autocomplete>
                <button
                    onClick={getCurrentLocation}
                    className="bg-gradient-to-b from-orange-400 to-orange-600 text-white px-4 py-2 rounded"
                >
                    Use My Location
                </button>
            </div>

            <GoogleMap
                mapContainerStyle={mapContainerStyle}
                zoom={14}
                center={location}
                onClick={onMapClick}
            >
                <Marker position={location} />
            </GoogleMap>

            <div className="text-sm mt-2">
                <p><strong>Latitude:</strong> {location.lat}</p>
                <p><strong>Longitude:</strong> {location.lng}</p>
                <p><strong>Address:</strong> {address}</p>
            </div>
        </div>
    );
};

export default MapPicker;
